import { render } from "./list-activity.vue?vue&type=template&id=a0747516"
import script from "./list-activity.vue?vue&type=script&lang=js"
export * from "./list-activity.vue?vue&type=script&lang=js"

import "./list-activity.vue?vue&type=style&index=0&id=a0747516&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__